import { render, staticRenderFns } from "./availability_and_interests.vue?vue&type=template&id=01d55bb9&"
import script from "./availability_and_interests.vue?vue&type=script&lang=js&"
export * from "./availability_and_interests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d55bb9')) {
      api.createRecord('01d55bb9', component.options)
    } else {
      api.reload('01d55bb9', component.options)
    }
    module.hot.accept("./availability_and_interests.vue?vue&type=template&id=01d55bb9&", function () {
      api.rerender('01d55bb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/availability_and_interests.vue"
export default component.exports